import servicePackage from './moduleServicePackage'
export default servicePackage
